import { supabase } from '../lib/supabase';

export const jobIdService = {
  // Get next job ID for a company (uses database function)
  async getNextJobId(companyId) {
    const { data, error } = await supabase
      ?.rpc('get_next_job_id', { p_company_id: companyId });

    if (error) throw error;

    return data;
  },

  // Get next instance number for a job (uses database function)
  async getNextInstanceNumber(jobId) {
    const { data, error } = await supabase
      ?.rpc('get_next_instance_number', { p_job_id: jobId });

    if (error) throw error;

    return data;
  },

  // Generate instance display ID from job display ID and instance number
  generateInstanceDisplayId(jobDisplayId, instanceNumber) {
    // Format: CLNPRO-JAN26-0001-#1 (hash prefix, no padding on instance number)
    return `${jobDisplayId}-#${instanceNumber}`;
  },

  // Get current month-year string (e.g., 'DEC25')
  getCurrentYearMonth() {
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
                    'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const now = new Date();
    const month = months[now.getMonth()];
    const year = String(now.getFullYear()).slice(-2);
    return `${month}${year}`;
  },

  // Parse a job display ID into components
  parseJobDisplayId(jobDisplayId) {
    if (!jobDisplayId) return null;

    const parts = jobDisplayId.split('-');
    if (parts.length < 3) return null;

    return {
      companyTag: parts[0],
      yearMonth: parts[1],
      sequenceNumber: parseInt(parts[2], 10)
    };
  },

  // Parse an instance display ID into components
  // Supports both old format (CLNPRO-DEC25-1-001) and new format (CLNPRO-JAN26-0001-#1)
  parseInstanceDisplayId(instanceDisplayId) {
    if (!instanceDisplayId) return null;

    const parts = instanceDisplayId.split('-');
    if (parts.length < 4) return null;

    // Check if last part has hash prefix (new format)
    const lastPart = parts[3];
    const instanceNumber = lastPart.startsWith('#')
      ? parseInt(lastPart.slice(1), 10)
      : parseInt(lastPart, 10);

    return {
      companyTag: parts[0],
      yearMonth: parts[1],
      jobSequence: parseInt(parts[2], 10),
      instanceNumber: instanceNumber
    };
  },

  // Get counter statistics for a company (for admin/reporting)
  async getCounterStats(companyId) {
    const { data, error } = await supabase
      ?.from('job_id_counters')
      ?.select('*')
      ?.eq('company_id', companyId)
      ?.order('year_month', { ascending: false });

    if (error) throw error;

    return data?.map(counter => ({
      id: counter?.id,
      companyId: counter?.company_id,
      yearMonth: counter?.year_month,
      currentCount: counter?.current_count,
      createdAt: counter?.created_at,
      updatedAt: counter?.updated_at
    }));
  }
};
